import React from 'react';

const PortfolioPage = () => {
  return (
    <div style={{ paddingTop: '80px', minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#dc2626' }}>Our Portfolio</h1>
        <p style={{ fontSize: '1.2rem' }}>Showcase of our amazing projects coming soon!</p>
      </div>
    </div>
  );
};

export default PortfolioPage;